import { api } from "./api";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

// Inscreve o aparelho para Web Push (VAPID) no endpoint da role correspondente.
// Funciona com o app em 2º plano, tela bloqueada ou fechado (service worker).
export async function inscreverPush(endpoint) {
  try {
    if (!("serviceWorker" in navigator) || !("PushManager" in window)) return false;
    const reg = await navigator.serviceWorker.register("/sw.js");
    if (Notification.permission === "default") await Notification.requestPermission();
    if (Notification.permission !== "granted") return false;
    const { data } = await api.get("/push/vapid-public");
    if (!data.publicKey) return false;
    const sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(data.publicKey),
    });
    await api.post(endpoint, { subscription: sub.toJSON() });
    return true;
  } catch {
    return false;
  }
}
